/* cspell: disable*/
import React from 'react';
import './registerUserDataDetails.less';
import { Theme } from '@theme';
import { CoreHelper, WithCoreProps, TranslationProps, ActionMetaService } from 'ff-shared-components-core';
import { Button, TitleContainer, RadioButton, OutputField, LinkLabel, PageScreen } from '@shared/components';
import { Popup } from 'semantic-ui-react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import {
	StoreState,
	getRegisterPharmacyInputData,
	RegisterInputData,
	RegisterFileUploadType,
	fetchDownloadRegisterDocumentByIdRequest,
} from '@store';
import { EnrollmentTypes } from '@api/ff-shared-services-api';
import { downloadFilePdf } from '@helpers';

interface RegisterUserDataDetailsState {
	idDocumentType: EnrollmentTypes.UserIdentificationDocumentType | undefined;
	idDocumentNumber: string;
	shortName: string;
	email: string;
	phonePrefix: string;
	phone: string;
	profileAccess: EnrollmentTypes.UserProfile | undefined;
	identificationDocumentFile: RegisterFileUploadType;
}

interface RegisterUserDataDetailsProps {
	userId: string;
	onClickBack(): void;
}

interface InjectedProps extends TranslationProps {
	theme: Theme;
	registerInputState: RegisterInputData;
	fetchDownloadRegisterDocumentByIdRequest: (fileId: string, metaData?: ActionMetaService) => void;
}

type Props = RegisterUserDataDetailsProps & InjectedProps;

class RegisterUserDataDetailsScreen extends React.PureComponent<Props, RegisterUserDataDetailsState> {
	public constructor(props: Props) {
		super(props);
		const { registerInputState, userId } = this.props;

		const userData = registerInputState.usersData && registerInputState.usersData.find(x => x.id === userId);

		this.state = {
			idDocumentType: userData ? userData.idDocumentType : EnrollmentTypes.UserIdentificationDocumentType.CC,
			idDocumentNumber: userData ? userData.idDocumentNumber : '',
			shortName: userData ? userData.shortName : '',
			phonePrefix: userData ? userData.phonePrefix : '+351',
			email: userData ? userData.email : '',
			phone: userData ? userData.phone : '',
			profileAccess: userData ? userData.profileAccess : undefined,
			identificationDocumentFile: {
				id: userData && userData.identificationDocument ? userData.identificationDocument.id : '',
				fileName: userData && userData.identificationDocument ? userData.identificationDocument.fileName : '',
				inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CC,
			},
		};

		window.scrollTo(0, 0);
	}

	public render(): JSX.Element {
		const { onClickBack, t, theme } = this.props;
		const {
			idDocumentType,
			idDocumentNumber,
			shortName,
			phonePrefix,
			email,
			phone,
			profileAccess,
			identificationDocumentFile,
		} = this.state;

		const signer = t<string>('radioButtons.userData.signer');
		const operator = t<string>('radioButtons.userData.operator');
		return (
			// <div id="page-user-details" className="page-user-details">
			// 	<div className="registerPharmacy-container user-details-container top-88px bottom-88px">
			<PageScreen name="page-user-details">
				<div className="title bottom-88px">
					<span>{t<string>('titles.registerPharmacy.userData.step1')}</span>
				</div>
				<div className="default-page-container">
					<div className="bottom-88px">
						<TitleContainer text={t('titleContainer.registerPharmacy.userData')} />

						<TitleContainer
							text={t('Tipo de documento de identificação')}
							content={(): React.ReactNode => (
								<div className="ds-form-radio-horizontal radios-4-in-line">
									<div>
										<RadioButton
											id={CoreHelper.guid()}
											isDisabled={true}
											labelText={'Cartão de cidadão'}
											value={EnrollmentTypes.UserIdentificationDocumentType.CC}
											isChecked={
												idDocumentType === EnrollmentTypes.UserIdentificationDocumentType.CC
											}
										/>
									</div>
									<div>
										<RadioButton
											id={CoreHelper.guid()}
											isDisabled={true}
											labelText={'BI'}
											value={EnrollmentTypes.UserIdentificationDocumentType.BI}
											isChecked={
												idDocumentType === EnrollmentTypes.UserIdentificationDocumentType.BI
											}
										/>
									</div>

									<div>
										<RadioButton
											id={CoreHelper.guid()}
											isDisabled={true}
											labelText={'Passaporte'}
											value={EnrollmentTypes.UserIdentificationDocumentType.PASSPORT}
											isChecked={
												idDocumentType ===
												EnrollmentTypes.UserIdentificationDocumentType.PASSPORT
											}
										/>
									</div>

									<div>
										<RadioButton
											id={CoreHelper.guid()}
											isDisabled={true}
											labelText={'Outros'}
											value={EnrollmentTypes.UserIdentificationDocumentType.OTHER}
											isChecked={
												idDocumentType === EnrollmentTypes.UserIdentificationDocumentType.OTHER
											}
										/>
									</div>
								</div>
							)}
						></TitleContainer>

						<div className="flex-column" style={{ marginBottom: '3.75rem' }}>
							<OutputField
								outputLabel={t<string>('label.shortName')}
								outputText={shortName}
								orientation="horizontal"
							/>
							<OutputField
								outputLabel={t<string>('label.email')}
								outputText={email}
								orientation="horizontal"
							/>
							<OutputField
								outputLabel={t<string>('label.phone')}
								outputText={/*phonePrefix +*/ phone}
								orientation="horizontal"
							/>
						</div>
					</div>

					<div className="bottom-88px">
						<TitleContainer
							text={t('titleContainer.registerPharmacy.access')}
							content={(): React.ReactNode => (
								<div className="ds-form-radio-horizontal">
									<div>
										<RadioButton
											isDisabled={true}
											isChecked={
												this.state.profileAccess === EnrollmentTypes.UserProfile.AUTHORIZED
											}
											id={CoreHelper.guid()}
											value={EnrollmentTypes.UserProfile.AUTHORIZED}
											labelText={signer}
											tooltip={(): React.ReactNode => (
												<Popup
													trigger={<img src={theme.image.tooltipIcon} alt="" />}
													content={t<string>('popups.profileAccess.signer')}
													position="bottom left"
												/>
											)}
										/>
									</div>
									<div>
										<RadioButton
											isDisabled={true}
											isChecked={
												this.state.profileAccess === EnrollmentTypes.UserProfile.OPERATOR
											}
											id={CoreHelper.guid()}
											value={EnrollmentTypes.UserProfile.OPERATOR}
											labelText={operator}
											tooltip={(): React.ReactNode => (
												<Popup
													trigger={<img src={theme.image.tooltipIcon} alt="" />}
													content={t<string>('popups.profileAccess.operator')}
													position="bottom left"
												/>
											)}
										/>
									</div>
								</div>
							)}
						></TitleContainer>
					</div>

					<div className="bottom-88px">
						<TitleContainer
							text={t('titleContainer.registerPharmacy.documentation')}
							content={(): React.ReactNode => (
								<div>
									{/* <OutputField
											outputLabel={t<string>('label.documentId')}
											additionalContent={(): React.ReactNode => (
												<span className="ds-text-link-files">
													{identificationDocumentName ? identificationDocumentName : ''}
												</span>
											)}
											orientation="horizontal"
										/> */}
									<OutputField
										outputLabel={'Documento de identificação'}
										additionalContent={() =>
											identificationDocumentFile ? (
												<span className="ds-text-link-files">
													<LinkLabel
														className="ds-text-link-appearance-2-underline"
														text={
															identificationDocumentFile &&
															identificationDocumentFile.fileName
																? identificationDocumentFile.fileName
																: ''
														}
														target="_blank"
														onClick={() =>
															this.downloadDocument(identificationDocumentFile.id)
														}
													/>
												</span>
											) : (
												'-'
											)
										}
									/>
								</div>
							)}
						></TitleContainer>
					</div>

					<div className="buttons-inline bottom-88px">
						<Button
							tertiary
							onClick={event => {
								event.preventDefault();
								onClickBack();
							}}
							// onClick={onClickBack}
							text={t<string>('buttons.general.back')}
						/>
					</div>
				</div>
				{/* </div>
			 </div> */}
			</PageScreen>
		);
	}

	private downloadDocument = (fileId: string): void => {
		const { fetchDownloadRegisterDocumentByIdRequest } = this.props;
		fetchDownloadRegisterDocumentByIdRequest(fileId, {
			successHandler: (file: EnrollmentTypes.File) => {
				if (file.data && file.name) {
					downloadFilePdf(file.data as string, file.name);
				}
			},
		});
	};
}

const mapStateToProps = (state: StoreState): object => ({
	registerInputState: getRegisterPharmacyInputData(state),
});

const mapDispatchToProps = (dispatch: Dispatch): object =>
	bindActionCreators({ fetchDownloadRegisterDocumentByIdRequest }, dispatch);

export default WithCoreProps<RegisterUserDataDetailsProps>(
	connect(mapStateToProps, mapDispatchToProps)(RegisterUserDataDetailsScreen)
);
